/** Wait for the sibling request that is rotating the browser's session cookies. */
export async function fetchWithRefreshConflictRetry(
  request: () => Promise<Response>,
  signal: AbortSignal
): Promise<Response> {
  for (let attempt = 0; ; attempt += 1) {
    signal.throwIfAborted()
    const response = await request()
    if (response.status !== 409 || attempt === 2) return response

    // The session routes send Retry-After: 1. Retrying after 300ms raced the
    // Set-Cookie response again, then left the auth probe unavailable for 30s.
    // Bound server-provided delays and keep the caller's timeout authoritative.
    const retryAfter = response.headers.get("Retry-After")
    const seconds = retryAfter === null ? NaN : Number(retryAfter)
    const delay = Number.isFinite(seconds)
      ? seconds * 1000
      : retryAfter
        ? Date.parse(retryAfter) - Date.now()
        : NaN
    const delayMs = Number.isFinite(delay) ? Math.min(3000, Math.max(1000, delay)) : 1000
    await new Promise<void>((resolve, reject) => {
      signal.throwIfAborted()
      const onAbort = () => {
        clearTimeout(timer)
        reject(signal.reason)
      }
      const timer = setTimeout(() => {
        signal.removeEventListener("abort", onAbort)
        resolve()
      }, delayMs)
      signal.addEventListener("abort", onAbort, { once: true })
    })
  }
}
